import React from "react";
import { Form } from "react-bootstrap";
import {
  SCOPE_FAMILIES,
  toggleScopes,
  unknownScopes,
} from "../utils/scopeCatalog";

// Os produtos que um cliente da calculator-api pode usar, agrupados por família.
// Usado na criação e na edição; quem chama guarda a lista e decide quando salvar.
//
// Os escopos que a tela não conhece aparecem crus, marcados e travados: o PATCH
// substitui a lista inteira, então desmarcá-los aqui os apagaria no cliente.
export default function ScopeSelector({ selectedScopes, onChange }) {
  const preservedScopes = unknownScopes(selectedScopes);

  const setChecked = (scopes, checked) =>
    onChange(toggleScopes(selectedScopes, scopes, checked));

  return (
    <>
      {selectedScopes.length === 0 && (
        <div className="alert alert-warning" role="alert">
          Nenhum produto marcado: o cliente não vai conseguir acessar nenhum
          produto.
        </div>
      )}

      {SCOPE_FAMILIES.map(family => {
        const familyScopes = family.scopes.map(({ scope }) => scope);
        const allChecked = familyScopes.every(scope =>
          selectedScopes.includes(scope),
        );
        const legendId = `scope-family-legend-${family.key}`;

        // o `legend` fica num flex ao lado do "Marcar todos", então deixa de
        // ser filho direto do `fieldset`: o nome do grupo vem do aria-labelledby
        return (
          <fieldset
            key={family.key}
            className="mb-5"
            aria-labelledby={legendId}
          >
            <div className="d-flex align-items-center mb-2">
              <legend id={legendId} className="h6 mb-0 mr-4 w-auto">
                {family.label}
              </legend>
              {familyScopes.length > 1 && (
                <Form.Check
                  type="checkbox"
                  id={`scope-family-${family.key}`}
                  label="Marcar todos"
                  checked={allChecked}
                  onChange={event =>
                    setChecked(familyScopes, event.target.checked)
                  }
                />
              )}
            </div>

            <div className="row">
              {family.scopes.map(({ scope, label }) => (
                <div className="col-md-6" key={scope}>
                  <Form.Check
                    type="checkbox"
                    id={`scope-${scope}`}
                    label={label}
                    checked={selectedScopes.includes(scope)}
                    onChange={event => setChecked([scope], event.target.checked)}
                  />
                </div>
              ))}
            </div>
          </fieldset>
        );
      })}

      {preservedScopes.length > 0 && (
        <fieldset>
          <legend className="h6">Outros</legend>
          <p className="text-muted mb-2">
            <small>
              Produtos que esta tela ainda não conhece. São mantidos ao salvar.
            </small>
          </p>
          {preservedScopes.map(scope => (
            <Form.Check
              key={scope}
              type="checkbox"
              id={`scope-${scope}`}
              label={<code>{scope}</code>}
              checked
              readOnly
              disabled
            />
          ))}
        </fieldset>
      )}
    </>
  );
}
